export const CALENDAR_INTEGRATION_SCROLL_ANCHOR = 'integration-calendar';
export const DOCUMENTATION_SKILL_INTEGRATION_SCROLL_ANCHOR =
  'integration-documentation-skill';
